// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Slider_sliderWrapper__1AQsi","pageNumber":"Slider_pageNumber__G7YGw","progressRate":"Slider_progressRate__2clVC","slider":"Slider_slider__1mcxH"};